/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CalibrationDataType } from './CalibrationDataType';
import {
    CalibrationDataTypeFromJSON,
    CalibrationDataTypeFromJSONTyped,
    CalibrationDataTypeToJSON,
} from './CalibrationDataType';
import type { CalibrationDataDtoCreatorUser } from './CalibrationDataDtoCreatorUser';
import {
    CalibrationDataDtoCreatorUserFromJSON,
    CalibrationDataDtoCreatorUserFromJSONTyped,
    CalibrationDataDtoCreatorUserToJSON,
} from './CalibrationDataDtoCreatorUser';
import type { CalibrationDataDtoCalibrationState } from './CalibrationDataDtoCalibrationState';
import {
    CalibrationDataDtoCalibrationStateFromJSON,
    CalibrationDataDtoCalibrationStateFromJSONTyped,
    CalibrationDataDtoCalibrationStateToJSON,
} from './CalibrationDataDtoCalibrationState';
import type { CalibrationDataSource } from './CalibrationDataSource';
import {
    CalibrationDataSourceFromJSON,
    CalibrationDataSourceFromJSONTyped,
    CalibrationDataSourceToJSON,
} from './CalibrationDataSource';

/**
 * 
 * @export
 * @interface CalibrationDataDto
 */
export interface CalibrationDataDto {
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof CalibrationDataDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CalibrationDataDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    masterDeviceId: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    erpDeviceId: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    calibrationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    calibrationCertificateNumber: string;
    /**
     * 
     * @type {CalibrationDataType}
     * @memberof CalibrationDataDto
     */
    calibrationDataType?: CalibrationDataType;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    dataVersion?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    calibratedBy?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    activationDate?: string | null;
    /**
     * 
     * @type {CalibrationDataDtoCalibrationState}
     * @memberof CalibrationDataDto
     */
    calibrationState?: CalibrationDataDtoCalibrationState | null;
    /**
     * 
     * @type {CalibrationDataSource}
     * @memberof CalibrationDataDto
     */
    calibrationDataSource?: CalibrationDataSource;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    deactivatedChambersDC?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    deactivatedChambersUC?: string | null;
    /**
     * 
     * @type {CalibrationDataDtoCreatorUser}
     * @memberof CalibrationDataDto
     */
    creatorUser?: CalibrationDataDtoCreatorUser | null;
    /**
     * 
     * @type {CalibrationDataDtoCreatorUser}
     * @memberof CalibrationDataDto
     */
    lastModifierUser?: CalibrationDataDtoCreatorUser | null;
    /**
     * 
     * @type {string}
     * @memberof CalibrationDataDto
     */
    $type?: CalibrationDataDtoTypeEnum;
}


/**
 * @export
 */
export const CalibrationDataDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCalibrationDataDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CalibrationDataDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CalibrationDataDtoTypeEnum = typeof CalibrationDataDtoTypeEnum[keyof typeof CalibrationDataDtoTypeEnum];



/**
 * Check if a given object implements the CalibrationDataDto interface.
 */
export function instanceOfCalibrationDataDto(value?: unknown): value is CalibrationDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CalibrationDataDtoTypeEnum)[0];
}

export function CalibrationDataDtoFromJSON(json: any): CalibrationDataDto {
    return CalibrationDataDtoFromJSONTyped(json, false);
}

export function CalibrationDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalibrationDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'masterDeviceId': json['masterDeviceId'],
        'erpDeviceId': json['erpDeviceId'],
        'calibrationDate': json['calibrationDate'] == null ? undefined : json['calibrationDate'],
        'calibrationCertificateNumber': json['calibrationCertificateNumber'],
        'calibrationDataType': json['calibrationDataType'] == null ? undefined : CalibrationDataTypeFromJSON(json['calibrationDataType']),
        'dataVersion': json['dataVersion'] == null ? undefined : json['dataVersion'],
        'calibratedBy': json['calibratedBy'] == null ? undefined : json['calibratedBy'],
        'activationDate': json['activationDate'] == null ? undefined : json['activationDate'],
        'calibrationState': json['calibrationState'] == null ? undefined : CalibrationDataDtoCalibrationStateFromJSON(json['calibrationState']),
        'calibrationDataSource': json['calibrationDataSource'] == null ? undefined : CalibrationDataSourceFromJSON(json['calibrationDataSource']),
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'deactivatedChambersDC': json['deactivatedChambersDC'] == null ? undefined : json['deactivatedChambersDC'],
        'deactivatedChambersUC': json['deactivatedChambersUC'] == null ? undefined : json['deactivatedChambersUC'],
        'creatorUser': json['creatorUser'] == null ? undefined : CalibrationDataDtoCreatorUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : CalibrationDataDtoCreatorUserFromJSON(json['lastModifierUser']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CalibrationDataDtoToJSON(value?: Omit<CalibrationDataDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'masterDeviceId': value['masterDeviceId'],
        'erpDeviceId': value['erpDeviceId'],
        'calibrationDate': value['calibrationDate'],
        'calibrationCertificateNumber': value['calibrationCertificateNumber'],
        'calibrationDataType': CalibrationDataTypeToJSON(value['calibrationDataType']),
        'dataVersion': value['dataVersion'],
        'calibratedBy': value['calibratedBy'],
        'activationDate': value['activationDate'],
        'calibrationState': CalibrationDataDtoCalibrationStateToJSON(value['calibrationState']),
        'calibrationDataSource': CalibrationDataSourceToJSON(value['calibrationDataSource']),
        'fileName': value['fileName'],
        'deactivatedChambersDC': value['deactivatedChambersDC'],
        'deactivatedChambersUC': value['deactivatedChambersUC'],
        'creatorUser': CalibrationDataDtoCreatorUserToJSON(value['creatorUser']),
        'lastModifierUser': CalibrationDataDtoCreatorUserToJSON(value['lastModifierUser']),
        '$type': value['$type'],
    });
}

